import React, { Component } from 'react'
import DatatableContainer from './Datatable.container'

class Datatable extends Component {
  constructor(props) {
    super(props)
    this.state = props
  }

  componentDidMount() {
    if (this.props.configEndpoint) {
      window.fetch(this.state.configEndpoint, {
        method: 'GET',
        credentials: 'same-origin'
      })
        .then((response) => {
          if (response.ok) {
            return response.json()
          }
        })
        .then((j) => {
          this.setState(j)
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }

  render() {
    if (this.state.endpoint) {
      return (
        <DatatableContainer {...this.state} />
      )
    }

    return (null)
  }
}

export default Datatable
export { default as rehydrator } from "./Datatable.rehydrator";
